import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography/Typography';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MessageIcon from '@material-ui/icons/Message';
import PagesIcon from '@material-ui/icons/List';
import AddPersonIcon from '@material-ui/icons/PersonAdd';
import ImportPeopleIcon from '@material-ui/icons/Phone';
import UsersIcon from '@material-ui/icons/People';
import ResponsesIcon from '@material-ui/icons/Reply';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import './Home.css';
import styles from './Home.style';
import { getUser, redirectToRoot } from '../../utilities/firebase-config';

class Home extends Component {
  state = {
    profile: {
      permissions: null,
    },
  }

  async componentDidMount() {
    const { history } = this.props;
    const user = await getUser();
    if (!user) {
      redirectToRoot(history);
    }

    this.setState({
      profile: user.profile,
    });
  }

  render() {
    const { classes } = this.props;
    const { profile: { permissions } } = this.state;

    return (
      <div className="Home container">
        <AppBar position="fixed" color="primary">
          <Toolbar>
            <Typography variant="h6" color="inherit">
              CCARES
            </Typography>
          </Toolbar>
        </AppBar>

        <div className={ classes.root }>
          <List component="nav">

            { (permissions === 'Administrator' || permissions === 'Sender') && (
              <Link to="/send-page">
                <ListItem button>
                  <ListItemIcon>
                    <MessageIcon />
                  </ListItemIcon>
                  <ListItemText primary="Send Page" />
                </ListItem>
              </Link>
            )}

            { permissions === 'Administrator' && (
              <Link to="/users">
                <ListItem button>
                  <ListItemIcon>
                    <UsersIcon />
                  </ListItemIcon>
                  <ListItemText primary="Users" />
                </ListItem>
              </Link>
            )}

            { permissions === 'Administrator' && (
              <Link to="/recipients">
                <ListItem button>
                  <ListItemIcon>
                    <AddPersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Notify List" />
                </ListItem>
              </Link>
            )}

            { permissions === 'Administrator' && (
              <Link to="/import-recipients">
                <ListItem button>
                  <ListItemIcon>
                    <ImportPeopleIcon />
                  </ListItemIcon>
                  <ListItemText primary="Import Numbers" />
                </ListItem>
              </Link>
            )}

            { permissions === 'Administrator' && (
              <Link to="/recent-pages">
                <ListItem button>
                  <ListItemIcon>
                    <PagesIcon />
                  </ListItemIcon>
                  <ListItemText primary="Recent Pages" />
                </ListItem>
              </Link>
            )}

            { permissions === 'Administrator' && (
              <Link to="/responses">
                <ListItem button>
                  <ListItemIcon>
                    <ResponsesIcon />
                  </ListItemIcon>
                  <ListItemText primary="Responses" />
                </ListItem>
              </Link>
            )}

          </List>
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withStyles(styles)(Home);
